import styled from "styled-components";

export const StyledClubPage = styled.div`
  padding: 1rem;

  .headers {
    display: flex;
    margin-top: 4rem;

    .project-name {
      width: 40%;
    }
  }
`;

export const ProjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin-top: 1rem;
`;

export const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 1rem;
  margin-top: 1rem;
`;

export const BreakdownInsightsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  row-gap: 1rem;
  margin-top: 1rem;
  justify-content: center;
`;

export const DoughnutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 1rem;
  margin-top: 1rem;
  justify-content: center;
`;

export const StyledClubCard = styled.div`
display: flex;
background-color: white;
box-shadow: 0px 0px 10px 1px #666666;
padding: 0.8rem;
align-items: center; 
h3 {
    font-weight: 400; 
    font-size: 1rem; 
    width: 40%; 
}
.span {
  flex-grow: 1; 
  width: 4rem; 
}
a {
  
  button {
  color: white;
    background-color: #ff363f;
    padding: 0.5rem;
    border-radius: 30px;
    border: none; 
  }
}

}
`;

export const Span = styled.span`
  border-radius: 30px;
  font-size: 0.8rem;
  color: white;
  padding: 0.5rem 1rem;
  background-color: ${(props) => {
    if (props.value < 3) {
      return "#FF323C";
    } else if (props.value === 3) {
      return "#FF9432";
    } else if (props.value > 3) return "#35BF6D";
    else return "darkgrey";
  }};
`;
